import i18n from '../../../translations/strings';
import { EventType, getMonthKey } from '../../../store/shared/make-reservation.store';
import moment from 'moment/moment';
import { Colors } from '../../../colors';
import log from '../../../utils/log';

export const defaultValuesDetailForm = {
  date: '',
  title: '',
  description: '',
  attendees: '',
  services: [],
  start: '',
  end: '',
  reservationOwner: '',
  reservationStatus: ''
}
export enum MakeReservationVariant {
  Customer = "Customer",
  AdminAllEvents = "AdminAllEvents",
  AdminHandleReservation = "AdminHandleReservation"
}

export enum DetailEventWindowVariant {
  Add = "Add",
  UpdateDelete = "UpdateDelete"
}
export const DetailEventWindowButtonTitle:  { [key: string]: string } = {
  [DetailEventWindowVariant.Add]: i18n.t('booking.addEvent'),
  [DetailEventWindowVariant.UpdateDelete]: i18n.t('booking.change'),
  [MakeReservationVariant.AdminAllEvents]: i18n.t('booking.goToReservation'),
};

export const eventStatusColor:  { [key: string]: string } = {
  'SENT': Colors.Sent,
  'CONFIRMED': Colors.Confirmed,
};

export const eventTextColor:  { [key: string]: string } = {
  [MakeReservationVariant.Customer]: Colors.PrimaryDark,
  [MakeReservationVariant.AdminAllEvents]: Colors.White,
  [MakeReservationVariant.AdminHandleReservation]: Colors.PrimaryDark
};


export const UnavailableBookingIntervals: any = [
  // {
  //   start: '0:00',
  //   end: '6:00'
  // },
  // {
  //   start: '23:00',
  //   end: '23:59'
  // }
]

export const getEventCreateAndUpdateErrors = (
  requestedEventStart: any,
  requestedEventEnd: any,
  events: any,
  selectedRoom: string,
  currentDateRange: string,
  isUpdating: boolean,
  selectedEvent: any
) => {

  if(!events[selectedRoom]) {
    return null;
  }

  if(!events[selectedRoom][getMonthKey(currentDateRange)]) {
    return null;
  }

  const eventsToCheck = isUpdating
    ? events[selectedRoom][getMonthKey(currentDateRange)].filter(((item: any) => item.id !== selectedEvent.id))
    : events[selectedRoom][getMonthKey(currentDateRange)];

  if (eventsToCheck.length === 0) {
    return null;
  }

  const startMoment = moment.utc(requestedEventStart);
  const endMoment = moment.utc(requestedEventEnd);

  if(startMoment.isBefore(moment())) {
    return i18n.t('booking.eventErrorBookOnPast');
  }

  for (const interval of UnavailableBookingIntervals) {
    const unavailabilityStart = moment(interval.start, 'HH:mm')
      .set({ year: startMoment.year(), month: startMoment.month(), date: startMoment.date() })
      .format('YYYY-MM-DD HH:mm');
    const unavailabilityEnd = moment(interval.end, 'HH:mm')
      .set({ year: endMoment.year(), month: endMoment.month(), date: endMoment.date() })
      .format('YYYY-MM-DD HH:mm');
    if (
      startMoment.isBetween(unavailabilityStart, unavailabilityEnd) ||
      endMoment.isBetween(unavailabilityStart, unavailabilityEnd) ||
      (startMoment.isBefore(unavailabilityStart) && endMoment.isAfter(unavailabilityEnd))
    ) {
      return i18n.t('booking.eventErrorRoomClose');
    }
  }

  log.debug('eventsToCheck', eventsToCheck)
  log.debug('startMoment', startMoment)
  log.debug('endMoment', endMoment)

  for (const booked of eventsToCheck) {
    const unavailabilityStart = moment.utc(booked.start)
    const unavailabilityEnd = moment.utc(booked.end);
    const endMoment = moment(requestedEventEnd)
    const startMoment = moment(requestedEventStart);
    if (
      startMoment.isBetween(unavailabilityStart, unavailabilityEnd) ||
      endMoment.isBetween(unavailabilityStart, unavailabilityEnd, null, '(]') ||
      (startMoment.isBefore(unavailabilityStart) && endMoment.isAfter(unavailabilityEnd)) || (startMoment.isSame(unavailabilityStart) && endMoment.isAfter(unavailabilityEnd))
    ) {
      log.debug('unavailabilityStart', unavailabilityStart)
      log.debug('unavailabilityEnd', unavailabilityEnd)
      return i18n.t('booking.eventErrorAlreadyBooked');
    }
  }
  return null;
}

export const getEventBgColor = (variant: MakeReservationVariant, event: any) => {
  if (event?.event?.extendedProps?.eventType === EventType.SelectedDateEvent) {
    return Colors.SelectedDateCalendar
  }
  if (event?.event?.extendedProps?.eventType === EventType.MyPendingEvent) {
    return Colors.Sent
  }
  if (variant === MakeReservationVariant.AdminAllEvents) {
    return eventStatusColor[event?.event?.extendedProps?.eventData?.booking?.status]
  } else if (variant === MakeReservationVariant.Customer || variant === MakeReservationVariant.AdminHandleReservation) {
    if (event?.event?.extendedProps?.eventType === EventType.Unavailability) {
      return Colors.Unavailability
    } else if (event?.event?.extendedProps?.eventType === EventType.ReadOnlyEvent) {
      return Colors.UnderlinedGrey
    }
    // else if (event?.event?.extendedProps?.eventType === EventType.ReadOnlyCustomer) {
    //   return Colors.Unselected
    // }
  } else {
    return Colors.Primary
  }
  return Colors.Primary
}

export const getDateRange = (date?: any) => {
  return {
    start: moment(date ? date : new Date()).subtract(1, 'months').endOf('month').startOf('week'),
    end: moment(date ? date : new Date()).add(1, 'months').startOf('month').endOf('week')
  }
}
